// Mirrors Rbac::PermissionMatrix::Resources and Actions from app/services/rbac/permission_matrix.rb
// Values use camelCase because deep_camelize_keys in inertia_share transforms the permissions hash
// keys before they reach the frontend (e.g. 'compliance_report' → 'complianceReport').
// Keep in sync when adding new resources or actions.

export const Resources = {
  DASHBOARD: 'dashboard',
  USER_MAINTENANCE: 'userMaintenance',
  INSTRUMENT_MAINTENANCE: 'instrumentMaintenance',
  REPORTS: 'reports',
  SYSTEM_SETTINGS: 'systemSettings',
  DEPARTMENT: 'department',
  SITE: 'site',
  INSTRUMENT_TASK: 'instrumentTask',
  INSTRUMENT_TASK_DATA_FIELD: 'instrumentTaskDataField',
  INSTRUMENT_TASK_LOG: 'instrumentTaskLog',
  INSTRUMENT_STATUS: 'instrumentStatus',
  INSTRUMENT_SERVICE_REPORT: 'instrumentServiceReport',
  INSTRUMENT_REPORTS: 'instrumentReports',
  LOT_MANAGEMENT: 'lotManagement',
  LOT_COMPARISON: 'lotComparison',
  NOTIFICATIONS_COMPLIANCE: 'notificationsCompliance',
  NOTIFICATIONS_SIGNATURES: 'notificationsSignatures',
  NOTIFICATION_PREFERENCES: 'notificationPreferences',
  SIGNOFF_CHAIN: 'signoffChain',
  COMPLIANCE_REPORT: 'complianceReport',
  COMMENTS: 'comments',
  ATTACHMENT: 'attachment',
  LOGGER: 'logger',
  FREQUENCIES: 'frequencies',
  RBAC: 'rbac',
  INSTRUMENT_DEPARTMENT: 'instrumentDepartment',
  CODE_VALUES: 'codeValues',
  CUSTOMER: 'customer',
  ORGANIZATION: 'organization',
  UNIT: 'unit',
  ADMIN_USER: 'adminUser',
  ADMIN_LOGGER: 'adminLogger',
  ADMIN_INSTRUMENT_TYPE: 'adminInstrumentType',
  ADMIN_INSTRUMENT_TAG: 'adminInstrumentTag',
  INSTRUMENT_TAG: 'instrumentTag',
  ADMIN_SCHEDULE: 'adminSchedule',
  PROFILE: 'profile',
} as const

export const Actions = {
  READ: 'read',
  CREATE: 'create',
  UPDATE: 'update',
  DELETE: 'delete',
  EXPORT: 'export',
} as const

export type Resource = (typeof Resources)[keyof typeof Resources]
export type Action = (typeof Actions)[keyof typeof Actions]
